require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-es-6-use-destructuring-assignment-to-pass-an-object-as-a-functions-parameters.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-es-6-use-destructuring-assignment-to-pass-an-object-as-a-functions-parameters");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-es-6-use-destructuring-assignment-to-pass-an-object-as-a-functions-parameters!./.cache/json/javascript-algorithms-and-data-structures-es-6-use-destructuring-assignment-to-pass-an-object-as-a-functions-parameters.json
// module id = 2386
// module chunks = 231608221292675